import { DateTime } from "luxon";
import React, { Component } from "react";
import { Card, CardHeader, CardBody, Tooltip } from "@chakra-ui/react";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import CoreService from "../../../../services/CoreService";
import DetailDisplay from "./DetailDisplay";

const columnDefs = [
  //Cant include nested values because access isnt guaranteed
  {
    headerName: "Log Type",
    field: "pollingTargetType",
    sortable: true,
    filter: true,
    resizable: true,
    maxWidth: 200,
  },
  {
    headerName: "Success",
    field: "successful",
    sortable: true,
    filter: true,
    resizable: true,
    minWidth: 200,
    maxWidth: 200,
    cellRenderer: function (params) { return (params.value) ? <FontAwesomeIcon icon={faCircleCheck} color='green' /> : <FontAwesomeIcon icon={faCircleXmark} color='red' /> } 
  },
  {
    headerName: "Polled At",
    field: "recordedDateTime",
    sortable: true,
    filter: true,
    resizable: true,
    maxWidth: 300,
    cellRenderer: function (params) {
      return DateTime.fromISO(params.value).toLocaleString(
        DateTime.DATETIME_SHORT_WITH_SECONDS
      );
    },
  },
  {
    headerName: "Source",
    field: "pollingSourceSystem",
    sortable: false,
    filter: true,
    resizable: true,
    maxWidth: 250,
  },
  {
    headerName: "Messages",
    field: "messages",
    sortable: true,
    filter: true,
    resizable: true,
    minWidth: 800,
    wrapText: true,
    autoHeight: true,
    cellRenderer: function (params) {
      return params.value.join(".   ");
    },
  },
];

var gridRef;

export default class LogGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      selectedRow: "",
      isDetailOpen: false
    };
    this.coreService = new CoreService();
    this.onRowDoubleClicked = this.onRowDoubleClicked.bind(this);
    this.onCloseDetailModal = this.onCloseDetailModal.bind(this);
  }

  async componentDidMount() {
    var newData = await this.fetchLogEntries();
    this.setState({ rowData: newData });
  }

  async fetchLogEntries() {
    var nabcShipDataResult = await this.coreService.fetchLog(
      "nabcshipments",
      this.props.hoursBefore,
      this.props.userSession.token
    );
    var nabcInvResult = await this.coreService.fetchLog(
      "nabcinv",
      this.props.hoursBefore,
      this.props.userSession.token
    );
    var gvaResult = await this.coreService.fetchLog(
      "gvabatch",
      this.props.hoursBefore,
      this.props.userSession.token
    );
    var mraCatalogsResult = await this.coreService.fetchLog(
      "mraCatalogRefresh",
      this.props.hoursBefore,
      this.props.userSession.token
    );
    var result = [
      ...nabcShipDataResult.dataResult,
      ...nabcInvResult.dataResult,
      ...gvaResult.dataResult,
      ...mraCatalogsResult.dataResult,
    ];
    return result;
  }

  onRowDoubleClicked(ev) {
    this.setState({
      selectedRow: ev.data,
      isDetailOpen: true
    });
  }

  onCloseDetailModal() {
    this.setState({
        isDetailOpen: false
    })
}


  render() {
    return (
      <div>
        <DetailDisplay
          selectedRow={this.state.selectedRow}
          isOpen={this.state.isDetailOpen}
          onClose={this.onCloseDetailModal}
          userSession={this.props.userSession}
        />

        <Card background="white" m="4">
          <CardHeader style={{ fontStyle: "italic", color: "#898787bd" }}>
            {this.props.title}
          </CardHeader>
          <CardBody>
            <Tooltip label="Double click to display details" placement="top">
              <div
                className="ag-theme-alpine"
                style={{ height: 400, width: "100%" }}
              >
                <AgGridReact
                  rowData={this.state.rowData}
                  columnDefs={columnDefs}
                  ref={gridRef}
                  rowSelection="single"
                  onRowDoubleClicked={(e) => this.onRowDoubleClicked(e)}
                />
              </div>
            </Tooltip>
          </CardBody>
        </Card>
      </div>
    );
  }
}
